import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { RootState } from 'App'
import { useFeatureFlag } from 'hooks/userFeatureFlag'

import { helpDesk } from 'utils/helper'
import SuggestionIcon from 'components/Common/SvgIcons/SuggestionIcon'
import QuestionMarkIcon from 'components/Common/SvgIcons/QuestionMarkIcon'
import { AppHelpCard } from 'components/Common/AppHelpCard/AppHelpCard.component'

export const AppToolCards = () => {
  const { t } = useTranslation()
  const user = useSelector((state: RootState) => state.user.user)
  const helpDeskEnabled = useFeatureFlag(user?.id || '', 'release-chatbot-get-help')

  return (
    <div>
      <div className="pt-3 pb-3">
        <AppHelpCard
          Icon={SuggestionIcon}
          label={t('tools.suggestTool')}
          handleOnClick={() =>
            window.open(
              'https://form.typeform.com/to/eV2JXFED?typeform-source=gotackle.typeform.com',
              '_blank'
            )
          }
        />
      </div>
      {helpDeskEnabled && (
        <AppHelpCard
          Icon={QuestionMarkIcon}
          label={t('tools.getHelp')}
          handleOnClick={() => helpDesk()}
        />
      )}
    </div>
  )
}
